/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_actions__add_to_itinerary = /** @type {(inputs: {}) => string} */ () => {
	return `Schritt`
};

const en_poi_actions__add_to_itinerary = /** @type {(inputs: {}) => string} */ () => {
	return `Step`
};

const es_poi_actions__add_to_itinerary = /** @type {(inputs: {}) => string} */ () => {
	return `Paso`
};

const fr_poi_actions__add_to_itinerary = /** @type {(inputs: {}) => string} */ () => {
	return `Étape`
};

const it_poi_actions__add_to_itinerary = /** @type {(inputs: {}) => string} */ () => {
	return `Passo`
};

const nl_poi_actions__add_to_itinerary = /** @type {(inputs: {}) => string} */ () => {
	return `Stap`
};

const pt_poi_actions__add_to_itinerary = /** @type {(inputs: {}) => string} */ () => {
	return `Etapa`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__add_to_itinerary = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_actions__add_to_itinerary(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_actions__add_to_itinerary", locale)
	if (locale === "de") return de_poi_actions__add_to_itinerary(inputs)
	if (locale === "en") return en_poi_actions__add_to_itinerary(inputs)
	if (locale === "es") return es_poi_actions__add_to_itinerary(inputs)
	if (locale === "fr") return fr_poi_actions__add_to_itinerary(inputs)
	if (locale === "it") return it_poi_actions__add_to_itinerary(inputs)
	if (locale === "nl") return nl_poi_actions__add_to_itinerary(inputs)
	return pt_poi_actions__add_to_itinerary(inputs)
};